import React, { useState, useEffect } from 'react';
import { hideMenu, setMenu } from '../../../../store/actions/CommonAction';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@mui/material/styles';
import { Box, Grid, IconButton } from '@mui/material';
import RealmSelector from '../../../common/realm/RealmSelector';
import {
	MENU_ARTIST,
	MENU_FANCLUB,
	MENU_MOBILE,
	MENU_MUSIC,
	MENU_PLANNER,
	MENU_STORE,
	MENU_SUPPORT,
	MENU_WEBSITE
} from '../../../../store/reducers/CommonReducer';
import RootMenu from './RootMenu';
import MenuWebsite from '../Menu/MenuWebsite';
import MenuArtist from '../Menu/MenuArtist';
import MenuMusic from '../Menu/MenuMusic';
import MenuPlanner from '../Menu/MenuPlanner';
import MenuFanclub from '../Menu/MenuFanclub';
import MenuStore from '../Menu/MenuStore';
import MenuSupport from '../Menu/MenuSupport';
import { useTranslation } from 'react-i18next';
import Button from '../../../common/inputs/Button';
import { ArrowBack, Close, Send } from '@mui/icons-material';
import ShareDialog from '../../appBar/ShareDialog';

const MobileMenuContainer = styled(Box)(({ theme }) => ({
	height: '100vh',
	width: '100vw',
	top: 0,
	left: 0,
	position: 'fixed',
	background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.03) 100%), #121212',
	overflow: 'auto',
	zIndex: theme.zIndex.drawer + 2,
	padding: theme.spacing(2),
	boxSizing: 'border-box',
}));

const Header = styled(Box)(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	marginBottom: theme.spacing(2),
	paddingBottom: theme.spacing(2),
	borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
}));

const ContentWrapper = styled(Box)(({ theme }) => ({
	paddingTop: theme.spacing(1),
}));

const MobileMenu = () => {
	const dispatch = useDispatch();
	const menu = useSelector(state => state.common.menu);
	const registryUrl = useSelector(state => state.registry.url);
	const { t } = useTranslation();
	const [showShare, setShowShare] = useState(false);

	useEffect(() => {
		if (menu) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = '';
		}
		return () => {
			document.body.style.overflow = '';
		};
	}, [menu]);

	if (!menu) {
		return null;
	}

	const handleHideMenu = () => dispatch(hideMenu());
	const handleSetMenu = (menuType) => dispatch(setMenu(menuType));

	const getMenuContent = () => {
		switch (menu) {
			case MENU_MOBILE:
				return <RootMenu />;
			case MENU_WEBSITE:
				return <MenuWebsite />;
			case MENU_ARTIST:
				return <MenuArtist />;
			case MENU_MUSIC:
				return <MenuMusic />;
			case MENU_PLANNER:
				return <MenuPlanner />;
			case MENU_FANCLUB:
				return <MenuFanclub />;
			case MENU_STORE:
				return <MenuStore />;
			case MENU_SUPPORT:
				return <MenuSupport />;
			default:
				return null;
		}
	};

	const handleBack = () => {
		if (menu === MENU_MOBILE) {
			handleHideMenu();
		} else {
			handleSetMenu(MENU_MOBILE);
		}
	};

	return (
		<MobileMenuContainer>
			<Header>
				<Button
					variant="text"
					startIcon={<ArrowBack />}
					onClick={handleBack}
					sx={{ color: 'rgba(255, 255, 255, 0.7)' }}
				>
					{t('back_btn')}
				</Button>
				<Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
					{registryUrl && (
						<Button
							color="primary"
							onClick={() => setShowShare(true)}
							startIcon={<Send />}
							variant="contained"
							size="small"
						>
							{t('share_title')}
						</Button>
					)}
					<IconButton
						onClick={handleHideMenu}
						sx={{ color: 'rgba(255, 255, 255, 0.7)' }}
						size="small"
					>
						<Close />
					</IconButton>
				</Box>
			</Header>

			<Grid container spacing={2}>
				<Grid item xs={12}>
					<RealmSelector fullwidth={true} />
				</Grid>
				<Grid item xs={12}>
					<ContentWrapper>
						{getMenuContent()}
					</ContentWrapper>
				</Grid>
			</Grid>

			<ShareDialog
				setOpen={(value) => {
					setShowShare(value);
					if (value) {
						setTimeout(() => {
							document.body.style.overflow = 'hidden';
						}, 300);
					}
				}}
				open={showShare}
			/>
		</MobileMenuContainer>
	);
};

export default MobileMenu;